

import {
  FETCH_ADMINS_REQUEST,
  FETCH_ADMINS_SUCCESS,
  FETCH_ADMINS_FAILURE,

  UPDATE_ADMIN_REQUEST,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAILURE,

  CREATE_ADMIN_REQUEST,
  CREATE_ADMIN_SUCCESS,
  CREATE_ADMIN_FAILURE,

  RESET_ADMIN_PASSWORD_REQUEST,
  RESET_ADMIN_PASSWORD_SUCCESS,
  RESET_ADMIN_PASSWORD_FAILURE,
} from "../actions/AdminActions";

const initialState = {
  loading: false,
  admins: [],
  error: null,

  updateSuccess: false,
  createSuccess: false,
  resetPasswordSuccess: false,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {

    /* ================= REQUEST ================= */
    case FETCH_ADMINS_REQUEST:
    case UPDATE_ADMIN_REQUEST:
    case CREATE_ADMIN_REQUEST:
    case RESET_ADMIN_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        updateSuccess: false,
        createSuccess: false,
        resetPasswordSuccess: false,
      };

    /* ================= FETCH ================= */
    case FETCH_ADMINS_SUCCESS:
      return {
        ...state,
        loading: false,
        admins: action.payload.data,
      };

    case FETCH_ADMINS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    /* ================= UPDATE ================= */
    case UPDATE_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSuccess: true,
      };

    case UPDATE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        updateSuccess: false,
      };

    /* ================= CREATE ================= */
    case CREATE_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        createSuccess: true,
      };

    case CREATE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        createSuccess: false,
      };

    /* ================= RESET PASSWORD ================= */
    case RESET_ADMIN_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        resetPasswordSuccess: true,
      };

    case RESET_ADMIN_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        resetPasswordSuccess: false,
      };

    default:
      return state;
  }
};

export default adminReducer;
